import { useRouter } from 'next/router';

import { Box, Heading, Paragraph } from '@zillow/constellation-10';

import { useGetListingDetails } from '../../../../hooks/queries/properties';
import propertyUtils from '../../../../utils/propertyUtils';

import {
  wizardFlexContainerStyles,
  wizardFormSectionContainerStyles,
  wizardHeadingStyles,
  wizardParagraphStyles,
} from '../../../../styles/wizard';

import AmenitiesWithAdditionalAmenitiesFields from '../../../PostingPath/AmenitiesWithAdditionalAmenitiesFields';
import PageWizard from '../../../Wizard/PageWizard';

import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const AmenitiesProperty = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}: WizardBodyTemplateProps) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const isRoomForRent = propertyUtils.isRoomForRent({ listing: listingDetails });

  const bodyContent = isRoomForRent
    ? 'Sharing more will help renters see themselves in the home.'
    : 'Sharing more will help renters see themselves in your home.';

  return (
    <PageWizard
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onGoToNextStep || undefined}
      onBackClick={onGoToPrevStep || undefined}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
      {...rest}
    >
      <div data-testid="AmenitiesProperty">
        <Box css={wizardFlexContainerStyles}>
          <Box data-testid="FormSectionContainer" css={wizardFormSectionContainerStyles.raw()}>
            <Heading textStyle="heading-sm" level={2} css={wizardHeadingStyles}>
              Property amenities
            </Heading>

            <Paragraph css={wizardParagraphStyles}>{bodyContent}</Paragraph>

            <AmenitiesWithAdditionalAmenitiesFields />
          </Box>
        </Box>
      </div>
    </PageWizard>
  );
};

export default AmenitiesProperty;
